<template>
  <b-field :label="label"
          :type="typeEmail"
          :message="messageEmail">
    <b-input ref="mail" v-model="model" :size="size" :disabled="disabled"></b-input>
  </b-field>
</template>
<script>
import { REGEX_EMAIL } from '@/configuration/regexConf';
import gestionType from '@/services/general/gestionType';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: String,
    label: String,
    size: String,
  },
  name: 'input-email',
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    model: {
      get() {
        return this.localValue;
      },
      set(newValue) {
        this.localValue = newValue;
        this.$emit('input', this.localValue);
      },
    },
    typeEmail() {
      return gestionType(!this.localValue
        || REGEX_EMAIL.test(this.localValue.toLowerCase()), true);
    },
    messageEmail() {
      if (this.localValue && !REGEX_EMAIL.test(this.localValue.toLowerCase())) {
        return this.$i18n.t('general.emailFormatError');
      }
      return '';
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
};
</script>
<style lang="scss">
</style>
